/**
 * @enum TableContentRendererType
 * @description Renderer types for table content
 */
export enum TableContentRendererEnum {
  /**
   * Plain text string renderer
   */
  String = 'string',

  /**
   * Angular TemplateRef renderer
   */
  Template = 'template',

  /**
   * Angular Type (component, directive) renderer
   */
  Type = 'type',

  /**
   * HTMLElement renderer
   */
  HTMLElement = 'html'
}

/**
 * @description Union type for table content renderer type
 */
export type TableContentRendererType = 
  | 'string'
  | 'template'
  | 'type'
  | 'html';

/**
 * @description Union type for table column renderer type that accepts both enum values and string literals
 */
export type ITableContentRendererType = TableContentRendererEnum | TableContentRendererType;

